var mm = function (el) {
    var btn = el,
        mm = document.getElementById('mm');

    //
    btn.onclick=function(){
        var cls = mm.className;
        if(cls.indexOf('js-active') === -1) mm.className = cls + ' js-active';
        else mm.className = cls.replace(' js-active', '');
    }
};

export {mm};